import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Home'
import FullScreenGrid from './FullScreenGrid'
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/fullscreengrid" element={<FullScreenGrid />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App